(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(81311);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 95532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ toAvgPriceNum; },
/* harmony export */   "y": function() { return /* binding */ toAvgPrice; }
/* harmony export */ });
var toAvgPrice = function(menu) {
    var ids = Object.keys(menu).map(Number);
    var totalPrice = ids.reduce(function(acc, itemID) {
        return acc + menu[itemID].price;
    }, 0);
    return "".concat(Math.round(totalPrice / ids.length / 1000)).length;
};
var toAvgPriceNum = function(menu) {
    var ids = Object.keys(menu).map(Number);
    var totalPrice = ids.reduce(function(acc, itemID) {
        return acc + menu[itemID].price;
    }, 0);
    return totalPrice / ids.length;
};



/***/ }),

/***/ 13886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ toAvgRating; }
/* harmony export */ });
var toAvgRating = function(ratings) {
    var ratingDisplay = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0
    };
    var ratingList = Object.keys(ratings);
    ratingList.map(function(userID) {
        var userRatings = ratings[userID];
        var latestRating = userRatings[userRatings.length - 1];
        if ((latestRating !== undefined && latestRating.rating) !== undefined) {
            ratingDisplay[latestRating.rating] += 1;
        }
    });
    var avgRating = ratingList.length !== 0 ? (Object.keys(ratingDisplay).map(Number).reduce(function(sum, star) {
        return star * ratingDisplay[star] + sum;
    }, 0) / ratingList.length).toFixed(1) : 0;
    return avgRating;
};



/***/ }),

/***/ 81311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(80343);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
;// CONCATENATED MODULE: ./styles/hero.ts


var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        heroImage: {
            objectFit: "cover",
            clipPath: "polygon(100% 0%, 100% 100%, calc(300px + 0%) 100%, 0% 0%)",
            objectPosition: "center center"
        },
        addressInputContainer: (0,_define_property/* default */.Z)({
            borderRadius: "24px",
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginTop: "3%",
            maxWidth: "600px"
        }, theme.breakpoints.down("sm"), {
            marginTop: "10%"
        }),
        addressInput: {
            width: "100%"
        },
        searchButton: {
            backgroundColor: "#D4451B",
            borderTopRightRadius: "24px",
            borderBottomRightRadius: "24px",
            height: "3.5em",
            width: "35%",
            color: "white"
        },
        buttonFullText: (0,_define_property/* default */.Z)({
            fontWeight: "bold"
        }, theme.breakpoints.down("sm"), {
            display: "none"
        }),
        buttonText: (0,_define_property/* default */.Z)({
            display: "none"
        }, theme.breakpoints.down("sm"), {
            fontWeight: "bold",
            display: "block"
        })
    };
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Homepage/HeroImage.tsx





var HeroImage = function() {
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "block",
        width: "58vw",
        height: "300px",
        position: "relative",
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                alt: "route-image",
                src: "https://firebasestorage.googleapis.com/v0/b/emenu-43dc6.appspot.com/o/emenu%2Fmulticuisinea.webp?alt=media&token=5454e3d8-89bb-44c5-a771-6597d2ab1dde",
                layout: "responsive",
                width: "100%",
                height: "100%",
                className: classes.heroImage
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                position: "absolute",
                display: "block",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                style: {
                    transform: "translateX(100%)",
                    transition: "transform 800ms ease-in-out 0s"
                }
            })
        ]
    });
};
/* harmony default export */ var Homepage_HeroImage = (HeroImage);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Homepage/HeroText.tsx



var HeroText = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        paddingTop: "2%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "h4",
                style: {
                    fontWeight: "bold"
                },
                children: "\u0110\u1ECBa \u0111i\u1EC3m g\u1EA7n b\u1EA1n"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                style: {
                    fontWeight: "bold",
                    color: "#1a0e01",
                    marginTop: "1%"
                },
                children: "Kh\xe1m ph\xe1 nh\u1EEFng \u0111\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt g\u1EA7n b\u1EA1n"
            })
        ]
    });
};
/* harmony default export */ var Homepage_HeroText = (HeroText);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(79895);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js + 1 modules
var InputBase = __webpack_require__(15575);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(41810);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOnOutlined.js
var LocationOnOutlined = __webpack_require__(71980);
// EXTERNAL MODULE: ./node_modules/@material-ui/lab/esm/Autocomplete/Autocomplete.js + 2 modules
var Autocomplete = __webpack_require__(34273);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/LocationOn.js
var LocationOn = __webpack_require__(59832);
// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/parse/index.js
var parse = __webpack_require__(23370);
var parse_default = /*#__PURE__*/__webpack_require__.n(parse);
// EXTERNAL MODULE: ./node_modules/autosuggest-highlight/match/index.js
var match = __webpack_require__(11447);
var match_default = /*#__PURE__*/__webpack_require__.n(match);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./constants/routes.ts + 3 modules
var routes = __webpack_require__(50870);
;// CONCATENATED MODULE: ./constants/mockAddresses.ts
var addresses = [
    {
        street: "54A Nguy\u1EC5n Ch\xed Thanh",
        ward: "Ph\u01B0\u1EDDng L\xe1ng Th\u01B0\u1EE3ng, Qu\u1EADn \u0110\u1ED1ng \u0110a",
        city: "H\xe0 N\u1ED9i",
        slug: "ha-noi",
        coordinate: {
            lat: 21.023678587586748,
            lng: 105.8093954490063
        }
    },
    {
        street: "To\xe0 170 La Th\xe0nh",
        ward: "P. \xd4 Ch\u1EE3 D\u1EEBa, Q. \u0110\u1ED1ng \u0110a",
        city: "H\xe0 N\u1ED9i",
        slug: "ha-noi",
        coordinate: {
            lat: 21.020913582678535,
            lng: 105.82757349715416
        }
    },
    {
        street: "29 Li\u1EC5u Giai",
        ward: "P. Ng\u1ECDc Kh\xe1nh, Q. Ba \u0110\xecnh",
        city: "H\xe0 N\u1ED9i",
        slug: "ha-noi",
        coordinate: {
            lat: 21.031278254602107,
            lng: 105.81348851249842
        }
    },
    {
        street: "46 Thanh Nh\xe0n",
        ward: "Hai B\xe0 Tr\u01B0ng",
        city: "H\xe0 N\u1ED9i",
        slug: "ha-noi",
        coordinate: {
            lat: 21.00298711050782,
            lng: 105.85795258180968
        }
    },
    {
        street: "131 Nguy\u1EC5n V\u0103n C\u1EEB",
        ward: "Ph\u01B0\u1EDDng Ng\u1ECDc L\xe2m, Qu\u1EADn Long Bi\xean",
        city: "H\xe0 N\u1ED9i",
        slug: "ha-noi",
        coordinate: {
            lat: 21.042268513751893,
            lng: 105.86993756831846
        }
    },
    {
        street: "101 Hu\u1EF3nh Th\xfac Kh\xe1ng",
        ward: "P.T\xe2n L\u1EADp",
        city: "Nha Trang",
        slug: "nha-trang",
        coordinate: {
            lat: 12.24348295727918,
            lng: 109.19068575469274
        }
    },
    {
        street: "09 Pasteur",
        ward: "P. X\u01B0\u01A1ng Hu\xe2n",
        city: "Nha Trang",
        slug: "nha-trang",
        coordinate: {
            lat: 12.251958580900409,
            lng: 109.1952873681847
        }
    },
    {
        street: "166 Nguy\u1EC5n Th\xe1i H\u1ECDc",
        ward: "P.V\u1EA1n Th\u1EA1nh",
        city: "Nha Trang",
        slug: "nha-trang",
        coordinate: {
            lat: 12.257647392118217,
            lng: 109.19008143934884
        }
    },
    {
        street: "1/6 V\xf5 Th\u1ECB S\xe1u",
        ward: "P.V\u0129nh Tr\u01B0\u1EDDng",
        city: "Nha Trang",
        slug: "nha-trang",
        coordinate: {
            lat: 12.206070772124976,
            lng: 109.20283345469237
        }
    },
    {
        street: "18 Hai B\xe0 Tr\u01B0ng",
        ward: "Ph\u01B0\u1EDDng B\u1EBFn Ngh\xe9, Qu\u1EADn 1",
        city: "TP H\u1ED3 Ch\xed Minh",
        slug: "tp-ho-chi-minh",
        coordinate: {
            lat: 10.777037163688448,
            lng: 106.7050423393331
        }
    },
    {
        street: "114 Tr\u1EA7n \u0110\xecnh Xu",
        ward: "Ph\u01B0\u1EDDng Nguy\u1EC5n C\u01B0 Trinh, Qu\u1EADn 1",
        city: "TP H\u1ED3 Ch\xed Minh",
        slug: "tp-ho-chi-minh",
        coordinate: {
            lat: 10.762350714504608,
            lng: 106.68915108166105
        }
    },
    {
        street: "424 Nguy\u1EC5n Th\u1ECB Minh Khai",
        ward: "Ph\u01B0\u1EDDng 5, Qu\u1EADn 3",
        city: "TP H\u1ED3 Ch\xed Minh",
        slug: "tp-ho-chi-minh",
        coordinate: {
            lat: 10.770409469583077,
            lng: 106.68583832584115
        }
    },
    {
        street: "226 C\xe1ch M\u1EA1ng Th\xe1ng 8",
        ward: "Ph\u01B0\u1EDDng 10, Qu\u1EADn 3",
        city: "TP H\u1ED3 Ch\xed Minh",
        slug: "tp-ho-chi-minh",
        coordinate: {
            lat: 10.780285421686042,
            lng: 106.67790969515303
        }
    }, 
];


;// CONCATENATED MODULE: ./components/Homepage/AddressInput.tsx












var AddressInput = function() {
    var classes = useStyles();
    var ref = (0,react.useState)(null), searchValue = ref[0], setSearchValue = ref[1];
    var ref1 = (0,react.useState)(""), inputValue = ref1[0], setInputValue = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
        component: "form",
        className: classes.addressInputContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.ZP, {
            style: {
                width: "100%"
            },
            disableListWrap: true,
            selectOnFocus: true,
            noOptionsText: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                children: "Kh\xf4ng t\xecm th\u1EA5y k\u1EBFt qu\u1EA3"
            }),
            options: addresses,
            getOptionLabel: function(option) {
                return "".concat(option.street, ", ").concat(option.ward, ", ").concat(option.city);
            },
            onChange: function(event, newSearchValue) {
                setSearchValue(newSearchValue);
            },
            getOptionSelected: function(option, value) {
                return option.street === value.street && option.ward === value.ward;
            },
            value: searchValue,
            onInputChange: function(event, newInputValue) {
                return setInputValue(newInputValue);
            },
            renderOption: function(option) {
                var optionFullText = "".concat(option.street, ", ").concat(option.ward, ", ").concat(option.city);
                var matches = match_default()(optionFullText, inputValue);
                var parts = parse_default()(optionFullText, matches);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    container: true,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOn/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: true,
                            children: parts.map(function(part, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    style: {
                                        fontWeight: part.highlight ? 700 : 400
                                    },
                                    children: "".concat(part.text)
                                }, "".concat(index));
                            })
                        })
                    ]
                });
            },
            renderInput: function(params) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(InputBase/* default */.Z, {
                    placeholder: "Nh\u1EADp v\u1ECB tr\xed hi\u1EC7n t\u1EA1i",
                    startAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationOnOutlined/* default */.Z, {
                        style: {
                            margin: "10px"
                        }
                    }),
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
                        className: classes.searchButton,
                        onClick: function() {
                            if (searchValue) {
                                sessionStorage.setItem("currentAddress", JSON.stringify(searchValue));
                                router_default().push(routes/* EXPLORE_LOCATION */.Xd(searchValue.slug));
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                className: classes.buttonFullText,
                                children: "Kh\xe1m ph\xe1 khu v\u1EF1c"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                className: classes.buttonText,
                                children: "Kh\xe1m ph\xe1"
                            })
                        ]
                    }),
                    className: classes.addressInput,
                    ref: params.InputProps.ref,
                    inputProps: params.inputProps
                });
            }
        })
    });
};
/* harmony default export */ var Homepage_AddressInput = (AddressInput);

;// CONCATENATED MODULE: ./components/Homepage/HeroWithAddressInput.tsx





var HeroWithAddressInput = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "flex",
        justifyContent: "flex-end",
        position: "relative",
        zIndex: 1,
        top: "0px",
        bgcolor: "#ffe0db",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage_HeroImage, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                className: "hero-text-input-container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage_HeroText, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage_AddressInput, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var Homepage_HeroWithAddressInput = (HeroWithAddressInput);

;// CONCATENATED MODULE: ./components/Homepage/index.tsx



// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/firebase/firestore/dist/index.esm.js + 3 modules
var index_esm = __webpack_require__(69160);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(18463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ImageList/ImageList.js
var ImageList = __webpack_require__(69685);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ImageListItem/ImageListItem.js
var ImageListItem = __webpack_require__(58108);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CardContent/CardContent.js
var CardContent = __webpack_require__(79912);
// EXTERNAL MODULE: ./styles/featuredPlace.ts
var featuredPlace = __webpack_require__(43453);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/ArrowForward.js
var ArrowForward = __webpack_require__(29973);
// EXTERNAL MODULE: ./helpers/toAvgRating.ts
var toAvgRating = __webpack_require__(13886);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./helpers/toAvgPrice.ts
var toAvgPrice = __webpack_require__(95532);
;// CONCATENATED MODULE: ./components/Homepage/FeaturedPlace.tsx













var FeaturedPlace = function(param) {
    var location = param.location, places = param.places;
    var classes = (0,featuredPlace/* useStyles */.y)();
    var theme = (0,useTheme/* default */.Z)();
    var isMobile = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        display: "grid",
        className: classes.responsiveGrid,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                gridArea: "header",
                className: classes.heading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h5",
                    component: "h1",
                    style: {
                        fontWeight: "bold",
                        marginRight: "1%"
                    },
                    children: "C\xe1c \u0111\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt \u1EDF ".concat(location.name)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                gridArea: "caption",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: classes.caption,
                        variant: "body2",
                        color: "textSecondary",
                        component: "p",
                        children: "".concat(location.places.length, " \u0111\u1ECBa \u0111i\u1EC3m \u1EDF ").concat(location.name)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: classes.seeMoreButton,
                        endIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForward/* default */.Z, {}),
                        onClick: function() {
                            sessionStorage.removeItem("currentAddress");
                            router_default().push(routes/* EXPLORE_LOCATION */.Xd(location.slug));
                        },
                        children: "Xem th\xeam c\xe1c \u0111\u1ECBa \u0111i\u1EC3m"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gridArea: "cards",
                children: places.map(function(place) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                        variant: "outlined",
                        className: classes.card,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                style: {
                                    display: "flex",
                                    flexWrap: "wrap",
                                    justifyContent: "space-around",
                                    overflow: "hidden",
                                    maxWidth: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageList/* default */.Z, {
                                    cols: isMobile ? 2.5 : 4,
                                    className: classes.responsiveImgList,
                                    rowHeight: 110,
                                    gap: 15,
                                    children: Object.keys(place.menu).map(Number).map(function(itemID) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageListItem/* default */.Z, {
                                            style: {
                                                display: "block"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: place.menu[itemID].image,
                                                alt: "".concat(place.menu[itemID].name, " image"),
                                                layout: "responsive",
                                                height: "100%",
                                                width: "100%",
                                                className: classes.image
                                            })
                                        }, "place-".concat(place.id, "-").concat(itemID));
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: routes/* PLACE_DETAIL */.KZ(place.id),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            gutterBottom: true,
                                            variant: "h6",
                                            component: "h2",
                                            className: classes.link,
                                            style: {
                                                fontWeight: "bold"
                                            },
                                            children: place.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "textSecondary",
                                        component: "p",
                                        children: place.type
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "body2",
                                        color: "textSecondary",
                                        component: "p",
                                        children: " ".concat((0,toAvgRating/* toAvgRating */.$)(place.rating), " \u2605 ").concat(Object.keys(place.rating).length, " \u0111\xe1nh gi\xe1 \u2022 ").concat("\u20AB".repeat((0,toAvgPrice/* toAvgPrice */.y)(place.menu)))
                                    })
                                ]
                            })
                        ]
                    }, "featured-".concat(place.id));
                })
            })
        ]
    });
};
/* harmony default export */ var Homepage_FeaturedPlace = (FeaturedPlace);

// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
;// CONCATENATED MODULE: ./pages/index.tsx






var __N_SSG = true;
function Home(param) {
    var places = param.places, locations = param.locations;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "M\u1ECDi \u0111\u1ECBa \u0111i\u1EC3m trong m\u1ED9t menu",
                description: "Trang ch\u1EE7 Emenu",
                openGraph: {
                    type: "website",
                    url: "https://emenu-green.vercel.app/",
                    title: "EMenu - M\u1ECDi \u0111\u1ECBa \u0111i\u1EC3m trong m\u1ED9t Menu",
                    description: "C\xe1c \u0111\u1ECBa \u0111i\u1EC3m \u0103n u\u1ED1ng n\u1ED5i b\u1EADt",
                    images: [
                        {
                            url: "https://firebasestorage.googleapis.com/v0/b/emenu-43dc6.appspot.com/o/emenu%2Flogo.png?alt=media&token=7d77c9ca-efa5-41be-8070-7d28a9999938",
                            alt: "EMenu logo"
                        }, 
                    ]
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage_HeroWithAddressInput, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                maxWidth: "md",
                style: {
                    paddingTop: "4%",
                    minWidth: "70vw"
                },
                children: locations.map(function(location) {
                    var placeList = places.filter(function(place) {
                        return location.places.includes(place.id);
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Homepage_FeaturedPlace, {
                        location: location,
                        places: placeList
                    }, "featured-".concat(location.slug));
                })
            })
        ]
    });
};


/***/ }),

/***/ 43453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14924);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);


var useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return {
        responsiveGrid: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            gridTemplate: "\n                  'header'\n                  'cards'\n                  'caption'\n                "
        }, theme.breakpoints.up("md"), {
            gridTemplate: "\n                  'header cards'\n                  'caption cards'\n                  'caption cards'\n                  'caption cards'\n                "
        }),
        responsiveImgList: {
            flexWrap: "nowrap",
            // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
            transform: "translateZ(0)",
            padding: "10px",
            width: "100%"
        },
        seeMoreButton: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            borderRadius: "15px",
            backgroundColor: "#e7e7e7",
            marginTop: "2%",
            maxWidth: "50%",
            fontSize: "0.7rem"
        }, theme.breakpoints.down("md"), {
            maxWidth: "90%",
            padding: "2% 5%",
            marginTop: "0",
            marginLeft: "auto",
            marginRight: "auto"
        }),
        heading: (_obj = {
            width: "27rem"
        }, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("md"), {
            paddingTop: "7%",
            paddingBottom: "5%"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, theme.breakpoints.down("sm"), {
            width: "100%"
        }), _obj),
        caption: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            fontSize: "1rem"
        }, theme.breakpoints.down("md"), {
            paddingTop: "7%",
            paddingBottom: "5%",
            marginLeft: "auto",
            marginRight: "auto"
        }),
        card: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
            paddingTop: "1%",
            marginBottom: "0rem",
            marginTop: "1%",
            width: "100%"
        }, theme.breakpoints.up("sm"), {
            width: "32rem",
            marginBottom: "1rem"
        }),
        link: {
            cursor: "pointer",
            "&:hover": {
                textDecoration: "underline"
            }
        },
        image: {
            objectFit: "fill",
            borderRadius: "5px"
        }
    };
});


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [17,363,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);